import { memo, useCallback } from "react";
import { Stack, TextField } from "@mui/material";
import { FieldFormCheckboxRow } from "../FieldFormCheckboxRow";
import { FieldTypeEditorProps } from "../types";

export const TextFieldTypeSpecificProps = memo(
  ({ field, onChange }: FieldTypeEditorProps) => {
    const updateProp = useCallback(
      <K extends keyof typeof field>(key: K, value: typeof field[K]) => {
        onChange({ ...field, [key]: value });
      },
      [field, onChange],
    );

    return (
      <Stack
        direction='row'
        spacing={2}
        alignItems='center'
        flexWrap='wrap'
        sx={{ pt: 0.5 }}
      >
        <FieldFormCheckboxRow
          label='Multiline'
          checked={!!field.multiline}
          onChange={(checked) => updateProp("multiline", checked)}
        />
        {field.multiline ? (
          <TextField
            label='Rows'
            type='number'
            value={field.rows ?? ""}
            onChange={(e) => {
              const nextValue = e.target.value;
              if (nextValue === "") {
                updateProp("rows", undefined);
                return;
              }
              const nextNumber = Number(nextValue);
              updateProp("rows", Number.isFinite(nextNumber) ? nextNumber : undefined);
            }}
            size='small'
            inputProps={{ min: 1 }}
            sx={{ width: 100 }}
          />
        ) : null}
      </Stack>
    );
  },
);
